/**
 * Resolve API base URL without importing api.ts (avoids circular deps with firebase).
 */
export const getApiBaseUrl = (): string => {
  if (process.env.REACT_APP_API_URL && process.env.REACT_APP_API_URL.trim().length > 0) {
    return process.env.REACT_APP_API_URL.trim();
  }

  if (typeof window !== 'undefined' && window.location.hostname === 'localhost') {
    return 'http://localhost:5001';
  }

  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    if (
      hostname === 'stockbai.com' ||
      hostname === 'www.stockbai.com' ||
      hostname === '157.180.89.57' ||
      hostname.endsWith('.web.app') ||
      hostname.endsWith('.firebaseapp.com') ||
      hostname.includes('stock-screener')
    ) {
      return '';
    }
  }

  if (process.env.NODE_ENV === 'development') {
    return 'http://localhost:5001';
  }

  return '';
};
